import React, { lazy } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { JWT_ACCESS_TOKEN_KEY } from "lib/network/jwt-token-access";
import Loadable from "layouts/full/shared/loadable/Loadable";
import ProgressBar from "./progressBar";

const FullLayout = Loadable(lazy(() => import("layouts/full/FullLayout")));

const AppRoute = () => {
  const token = localStorage.getItem(JWT_ACCESS_TOKEN_KEY);

  return (
    <>
      <ProgressBar />
      {token ? (
        <FullLayout>
          <Outlet />
        </FullLayout>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
};

export default AppRoute;
